export default __webpack_public_path__ + "static/media/flag-pt.27b1d513.svg";